import { render, staticRenderFns } from "./cluesList.vue?vue&type=template&id=c06d6d56&scoped=true&"
import script from "./cluesList.vue?vue&type=script&lang=js&"
export * from "./cluesList.vue?vue&type=script&lang=js&"
import style0 from "./cluesList.vue?vue&type=style&index=0&id=c06d6d56&lang=scss&scoped=true&"
import style1 from "./cluesList.vue?vue&type=style&index=1&id=c06d6d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d6d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06d6d56')) {
      api.createRecord('c06d6d56', component.options)
    } else {
      api.reload('c06d6d56', component.options)
    }
    module.hot.accept("./cluesList.vue?vue&type=template&id=c06d6d56&scoped=true&", function () {
      api.rerender('c06d6d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/lostManagement/cluesList.vue"
export default component.exports